import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { PrestoObjectDataset } from 'app/model/dataset/presto.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.presto.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(PrestoObjectDataset) }
})
export class PrestoCopySource extends TabularCopySource {
}
